import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { selectCompanyLeadSourcesValues } from 'store/companies/selectors';

import { getCompany } from './company.selectors';

const selectPhoneNumbers = createSelector(getCompany, ({ phoneNumbers }) => phoneNumbers);

export const selectUniqueLeadSourcePhoneNumbersById = memoizeOne(id =>
  createSelector(
    [selectPhoneNumbers, selectCompanyLeadSourcesValues],
    (phoneNumbers, leadSources) => {
      const phoneNumbersInLeadSources = leadSources.reduce(
        (acc, { leadSourceId, phoneNumbers }) => {
          if (leadSourceId !== id) {
            acc.push(...phoneNumbers);
          }

          return acc;
        },
        [],
      );

      return phoneNumbers.reduce((acc, item) => {
        if (!phoneNumbersInLeadSources.includes(item)) {
          acc.push({ value: item });
        }

        return acc;
      }, []);
    },
  ),
);
